export const TOSv2 = () => {
  return (
    <div className="accept-terms-modal__description">
      <p className="mb-3">
        Please review our{' '}
        <a href="https://www.willowservicing.com/tos" target="_blank" rel="noopener noreferrer">
          Terms
        </a>
        {', '}
        <a href="https://www.willowservicing.com/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        {', '}
        and{' '}
        <a href="https://www.willowservicing.com/paperless-disclosures" target="_blank" rel="noopener noreferrer">
          Paperless Disclosures
        </a>
        .
      </p>

      <h3 className="mb-3">Please review our payment partners’ below: </h3>

      <p>
        Dwolla:{' '}
        <a href="https://www.dwolla.com/legal/tos/" target="_blank" rel="noopener noreferrer">
          Terms
        </a>{' '}
        and{' '}
        <a href="https://www.dwolla.com/legal/privacy/" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </p>

      <p>
        Repay:{' '}
        <a href="https://repay.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
          Terms
        </a>{' '}
        and{' '}
        <a href="https://repay.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </p>
    </div>
  );
};
